import Banner from './Banner.component';

export default Banner;
